import React from 'react';
import './styles.scss';
import { APPCONFIG } from '../../app.config';

const Footer = () => {
  const { PORTAL, ENVIRONMENT, VERSION, BUTTON_TEXT } = APPCONFIG.FOOTER;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-info">
          <span className="footer-text">
            © {currentYear}  {PORTAL} 
          </span>
        </div>
        <div className="footer-links">
          <p className="footer-link">{ENVIRONMENT} | {VERSION}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
